module.exports = __webpack_public_path__ + "static/img/GEORGE-STEVENS.7c6d362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GEORGE-STEVENS.jpg
// module id = BR1T
// module chunks = 0